import React, { useState, useEffect } from "react";
import {
  Button,
  Stack,
  Grid,
  Modal,
  Text,
  Space,
  TextInput,
  Tooltip,
  Image,
  Flex,
} from "@mantine/core";
import { useTranslation } from "react-i18next";
import entityIcon from "@util/entityIcon";
import entityColor from "@util/entityColor";
import axios from "axios";

export default function AssetLibraryPicker({ onSelect, reqData = {}, title }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    if (!open) return;

    fetchItems();
  }, [open]);

  useEffect(() => {
    if (!searchValue) return;
    fetchItems(searchValue);
  }, [searchValue]);

  function fetchItems(value) {
    setLoading(true);
    setSearchValue(value);

    const req = { ...reqData };

    if (value) req.value = value;

    axios
      .post(`/retrieve-library-assets/`, { ...req })
      .then(({ data }) => {
        setItems(data.response[0].data);
        setLoading(false);
      })
      .catch((err) => {
        setItems([]);
        setLoading(false);
      });
  }

  function onModalClose() {
    setOpen(false);
    // onClose();
  }

  return (
    <React.Fragment>
      <Button
        onClick={() => setOpen(true)}
        leftSection={entityIcon.library()}
        color={entityColor.library}
        size="xs"
        radius="xl"
      >
        {title ? title : "Asset Library"}
      </Button>
      <Modal
        size="xl"
        opened={open}
        onClose={() => onModalClose()}
        withCloseButton={false}
      >
        {!loading && items.length === 0 && (
          <Text mb="xl">{t("common:no_results")}</Text>
        )}
        {loading && <Text mb="xl">{t("common:loading")}</Text>}
        <TextInput
          placeholder={t("common:search")}
          value={searchValue}
          size="md"
          onChange={(e) => setSearchValue(e.target.value)}
        />
        <Space mt="lg" />
        <Grid>
          {items.map((item) => (
            <Grid.Col span={{ base: 12, md: 12 }} key={item.id}>
              <Flex gap="sm" align="center">
                <div>
                  <a href={item.filename_url} target="blank">
                    <Image
                      src={item.filename_url}
                      style={{
                        width: "100px",
                        height: "100px",
                        objectFit: "cover",
                      }}
                    />
                  </a>
                </div>
                <Stack gap="xs" style={{ flexGrow: 1 }}>
                  <Tooltip label={item.original_filename}>
                    <Text lineClamp={1}>{item.original_filename}</Text>
                  </Tooltip>
                  <Button
                    size="sm"
                    radius="xl"
                    style={{ width: "fit-content" }}
                    onClick={() => {
                      onSelect(item.asset_id);
                      onModalClose();
                    }}
                  >
                    {t("common:select")}
                  </Button>
                </Stack>
              </Flex>
            </Grid.Col>
          ))}
        </Grid>
      </Modal>
    </React.Fragment>
  );
}
